/**
 * Diwali Festive page — FAQ, infinite product grid, add to cart + qty stepper.
 */
(function () {
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function festiveRoot() {
    return document.getElementById('diwali-festive-root');
  }

  function initFaq() {
    document.querySelectorAll('[data-diwali-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('aria-controls');
        var panel = id ? document.getElementById(id) : null;
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
        var chevron = btn.querySelector('[data-diwali-faq-chevron]');
        if (chevron) chevron.textContent = open ? '▶' : '▼';
      });
    });
  }

  function initCartOpen() {
    var openBtn = document.querySelector('[data-diwali-open-cart]');
    if (!openBtn) return;
    openBtn.addEventListener('click', function () {
      var floatBtn = document.querySelector('[data-if-float-cart-open]');
      if (floatBtn) {
        floatBtn.click();
        return;
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    });
  }

  function updateDiwaliCartCount(count) {
    var el = document.querySelector('[data-diwali-cart-count]');
    if (el) el.textContent = String(count);
  }

  function updateDiwaliCard(card, qty) {
    if (!card) return;
    var addBtn = card.querySelector('[data-diwali-add]');
    var ctrl = card.querySelector('[data-diwali-qty-ctrl]');
    var num = card.querySelector('[data-diwali-qty-num]');
    if (!addBtn || !ctrl) return;

    if (qty > 0) {
      addBtn.hidden = true;
      ctrl.hidden = false;
      if (num) num.textContent = qty > 99 ? '99+' : String(qty);
    } else {
      addBtn.hidden = false;
      ctrl.hidden = true;
      if (num) num.textContent = '0';
    }
  }

  function applyCartToDiwaliCards(cart) {
    var items = (cart && cart.items) || [];
    var byVariant = Object.create(null);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var vid = String(item.variant_id);
      if (!byVariant[vid]) {
        byVariant[vid] = { qty: 0, key: item.key || '' };
      }
      byVariant[vid].qty += item.quantity || 0;
      byVariant[vid].key = item.key || byVariant[vid].key;
    }

    var root = festiveRoot();
    if (!root) return;
    root.querySelectorAll('[data-diwali-variant-id]').forEach(function (card) {
      var vid = card.getAttribute('data-diwali-variant-id');
      if (!vid) return;
      var entry = byVariant[vid];
      var qty = entry ? entry.qty : 0;
      updateDiwaliCard(card, qty);
      if (entry && entry.key) card.setAttribute('data-diwali-line-key', entry.key);
      else card.removeAttribute('data-diwali-line-key');
    });

    if (cart && cart.item_count != null) updateDiwaliCartCount(cart.item_count);
  }

  function refreshDiwaliCartQty() {
    return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyCartToDiwaliCards(cart);
        return cart;
      })
      .catch(function () {});
  }

  function dispatchCartEvents(cart) {
    var payload = { cart: cart };
    ['cart:refresh', 'cart:updated', 'cart:item-added', 'cart:update'].forEach(function (name) {
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: payload }));
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: payload }));
    });
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'diwali-festive', cartData: cart });
    }
    if (window.IfFloatingCart && typeof window.IfFloatingCart.refresh === 'function') {
      window.IfFloatingCart.refresh();
    }
  }

  function setQtyBusy(card, on) {
    var ctrl = card.querySelector('[data-diwali-qty-ctrl]');
    if (!ctrl) return;
    ctrl.classList.toggle('is-busy', on);
    ctrl.querySelectorAll('button').forEach(function (b) {
      b.disabled = on;
    });
  }

  function resolveDiwaliLineKey(variantId, staleKey) {
    return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        if (staleKey && items.some(function (item) { return item.key === staleKey; })) {
          return staleKey;
        }
        var matches = items.filter(function (item) {
          return String(item.variant_id) === String(variantId);
        });
        if (matches.length === 1) return matches[0].key || '';
        if (matches.length > 1 && staleKey) return staleKey;
        return matches[0] ? matches[0].key || '' : '';
      })
      .catch(function () {
        return staleKey || '';
      });
  }

  function refreshOpenCartDrawer() {
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.onCartUpdate === 'function') {
      drawerItems.onCartUpdate();
    }
  }

  function changeDiwaliQty(card, variantId, newQty) {
    var qty = Math.max(0, newQty);
    var staleKey = card.getAttribute('data-diwali-line-key');
    setQtyBusy(card, true);
    updateDiwaliCard(card, qty);

    return resolveDiwaliLineKey(variantId, staleKey)
      .then(function (lineKey) {
        var body;
        var url;
        if (lineKey) {
          body = JSON.stringify({ id: lineKey, quantity: qty });
          url = cartRoot() + 'cart/change.js';
        } else {
          var updates = Object.create(null);
          updates[String(variantId)] = qty;
          body = JSON.stringify({ updates: updates });
          url = cartRoot() + 'cart/update.js';
        }

        return fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: body
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            if (cart && cart.status) throw new Error(cart.description || cart.message || 'Cart update failed');
            if (cart && cart.errors) throw new Error(typeof cart.errors === 'string' ? cart.errors : 'Cart update failed');
            applyCartToDiwaliCards(cart);
            dispatchCartEvents(cart);
            refreshOpenCartDrawer();
            return cart;
          });
      })
      .catch(function () {
        return refreshDiwaliCartQty().then(function () {
          refreshOpenCartDrawer();
        });
      })
      .finally(function () {
        setQtyBusy(card, false);
      });
  }

  function refreshDrawerFromAdd(data) {
    if (window.AVADA_CART_DRAWER && window.AVADA_CART_DRAWER.settings && window.AVADA_CART_DRAWER.settings.status) {
      if (typeof window.aovCartDrawerRefresh === 'function') window.aovCartDrawerRefresh();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && data.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(data);
    }
    refreshOpenCartDrawer();
  }

  function addToCart(variantId, card) {
    var addBtn = card.querySelector('[data-diwali-add]');
    var label = addBtn ? addBtn.textContent : 'Add to Cart';
    if (addBtn) {
      addBtn.classList.add('is-busy');
      addBtn.textContent = 'Adding…';
    }

    var sections = ['cart-drawer', 'cart-icon-bubble'];
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }

    fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        if (addBtn) {
          addBtn.classList.remove('is-busy');
          addBtn.textContent = label;
        }
        return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            applyCartToDiwaliCards(cart);
            dispatchCartEvents(cart);
            refreshDrawerFromAdd(data);
            return cart;
          });
      })
      .catch(function () {
        if (addBtn) {
          addBtn.classList.remove('is-busy');
          addBtn.textContent = label;
        }
      });
  }

  function initAddToCart() {
    var root = festiveRoot();
    if (!root || root.dataset.diwaliCartBound === 'true') return;
    root.dataset.diwaliCartBound = 'true';

    root.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-diwali-qty-minus]');
      var plus = e.target.closest('[data-diwali-qty-plus]');
      if (minus || plus) {
        var stepCard = e.target.closest('[data-diwali-variant-id]');
        if (!stepCard) return;
        e.preventDefault();
        e.stopPropagation();
        var variantId = stepCard.getAttribute('data-diwali-variant-id');
        var numEl = stepCard.querySelector('[data-diwali-qty-num]');
        var current = parseInt(numEl && numEl.textContent, 10) || 0;
        changeDiwaliQty(stepCard, variantId, current + (plus ? 1 : -1));
        return;
      }

      var btn = e.target.closest('[data-diwali-add]');
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest('[data-diwali-variant-id]');
      var id = btn.getAttribute('data-variant-id');
      if (!id) {
        window.location.href = btn.getAttribute('data-product-url') || '/';
        return;
      }
      addToCart(id, card || btn.closest('.diwali-card'));
    });

    ['cart:updated', 'cart:item-added', 'cart:refresh', 'cart:update'].forEach(function (name) {
      document.addEventListener(name, function (e) {
        if (!festiveRoot()) return;
        var detail = e.detail;
        var cart = detail && (detail.cart || (detail.items ? detail : null));
        if (cart && cart.items) applyCartToDiwaliCards(cart);
        else refreshDiwaliCartQty();
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!festiveRoot()) return;
        if (event && event.cartData && event.cartData.items) applyCartToDiwaliCards(event.cartData);
        else refreshDiwaliCartQty();
      });
    }

    refreshDiwaliCartQty();
  }

  var infiniteState = {
    el: null,
    grid: null,
    sentinel: null,
    spinner: null,
    sectionId: '',
    nextUrl: '',
    loading: false,
    done: false,
    armed: true,
    lastScrollY: 0,
    ticking: false
  };

  function bindInfinite(root) {
    var el = (root || document).querySelector('diwali-festive-infinite');
    if (!el) return false;
    infiniteState.el = el;
    infiniteState.grid = document.getElementById('diwali-product-grid');
    infiniteState.sentinel = el.querySelector('[data-infinite-sentinel]');
    infiniteState.spinner = el.querySelector('[data-infinite-spinner]');
    infiniteState.sectionId = el.getAttribute('data-section-id') || '';
    infiniteState.nextUrl = el.getAttribute('data-next-url') || '';
    infiniteState.loading = false;
    infiniteState.done = !infiniteState.nextUrl;
    infiniteState.armed = true;
    infiniteState.lastScrollY = window.scrollY || 0;

    if (!infiniteState.grid || !infiniteState.nextUrl) {
      el.setAttribute('hidden', '');
      infiniteState.done = true;
      return false;
    }
    el.removeAttribute('hidden');
    return true;
  }

  function infiniteShouldLoad() {
    if (infiniteState.done || infiniteState.loading || !infiniteState.nextUrl || !infiniteState.armed) {
      return false;
    }
    var marker = infiniteState.sentinel || infiniteState.el;
    if (!marker) return false;
    var rect = marker.getBoundingClientRect();
    var viewH = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewH * 1.15;
  }

  function infiniteLoadNext() {
    if (infiniteState.done || infiniteState.loading || !infiniteState.nextUrl || !infiniteState.armed) return;
    infiniteState.armed = false;
    infiniteState.loading = true;
    if (infiniteState.spinner) infiniteState.spinner.hidden = false;

    var u = new URL(infiniteState.nextUrl, window.location.origin);
    if (infiniteState.sectionId) u.searchParams.set('section_id', infiniteState.sectionId);

    fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load page');
        return res.text();
      })
      .then(function (htmlText) {
        var doc = new DOMParser().parseFromString(htmlText, 'text/html');
        var nextGrid = doc.getElementById('diwali-product-grid');
        var nextLoader = doc.querySelector('diwali-festive-infinite');

        if (nextGrid && infiniteState.grid) {
          Array.prototype.forEach.call(nextGrid.children, function (item) {
            infiniteState.grid.appendChild(document.importNode(item, true));
          });
          refreshDiwaliCartQty();
        }

        var newNext = nextLoader ? nextLoader.getAttribute('data-next-url') || '' : '';
        infiniteState.nextUrl = newNext;
        if (infiniteState.el) infiniteState.el.setAttribute('data-next-url', newNext);
        if (!newNext) {
          infiniteState.done = true;
          if (infiniteState.el) infiniteState.el.setAttribute('hidden', '');
        }
      })
      .catch(function (err) {
        console.error('[diwali-festive-infinite]', err);
        infiniteState.armed = true;
      })
      .finally(function () {
        infiniteState.loading = false;
        if (infiniteState.spinner) infiniteState.spinner.hidden = true;
      });
  }

  function onInfiniteScroll() {
    if (infiniteState.ticking || infiniteState.done) return;
    infiniteState.ticking = true;
    requestAnimationFrame(function () {
      infiniteState.ticking = false;
      var y = window.scrollY || 0;
      if (!infiniteState.armed && !infiniteState.loading && y > infiniteState.lastScrollY + 80) {
        infiniteState.armed = true;
      }
      infiniteState.lastScrollY = y;
      if (infiniteShouldLoad()) infiniteLoadNext();
    });
  }

  function initInfinite(root) {
    if (!bindInfinite(root || document)) return;
    window.addEventListener('scroll', onInfiniteScroll, { passive: true });
    window.addEventListener('touchmove', onInfiniteScroll, { passive: true });
    window.addEventListener('resize', onInfiniteScroll, { passive: true });
    setTimeout(function () {
      if (infiniteShouldLoad()) infiniteLoadNext();
    }, 150);
  }

  function boot() {
    if (!festiveRoot()) return;
    initFaq();
    initCartOpen();
    initAddToCart();
    initInfinite(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    boot();
  });
})();
